import { isAxiosError } from "axios"

export const getSolarProposalErrorStatus = (
  error: unknown,
): number | undefined =>
  isAxiosError(error) ? error.response?.status : undefined

/** Access answers: the reader cannot or may not see the proposal. */
const ACCESS_STATUSES = new Set([401, 403, 404])

/** Answers rather than transient failures: access, validation, a conflict. */
const ANSWER_STATUSES = new Set([400, 401, 403, 404, 409])

/** Retry for a Solar Proposal read: everything but an access answer, thrice. */
export const retrySolarRead = (failureCount: number, error: unknown): boolean =>
  !ACCESS_STATUSES.has(getSolarProposalErrorStatus(error) ?? 0) &&
  failureCount < 3

/** Retry for a Solar Proposal setup read: transient failures only, thrice. */
export const retrySolarSetupRead = (
  failureCount: number,
  error: unknown,
): boolean =>
  !ANSWER_STATUSES.has(getSolarProposalErrorStatus(error) ?? 0) &&
  failureCount < 3
